import { render, staticRenderFns } from "./AppointmentBehavior.vue?vue&type=template&id=4f578bfa&scoped=true&"
import script from "./AppointmentBehavior.vue?vue&type=script&lang=js&"
export * from "./AppointmentBehavior.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentBehavior.vue?vue&type=style&index=0&id=4f578bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f578bfa",
  null
  
)

export default component.exports